import React from 'react';
import QrScanner from 'qr-scanner';
import { Button} from 'konsta/react';


class CustomQrcodePlugin extends React.Component {
    render() {
        return (
            <div style={{textAlign: 'center'}}>
            <div id="video-container">
                <video id="qr-video"></video>
            </div>
            <select id="cam-list" defaultValue={'environment'}>
                <option value="environment">Environment Facing (default)</option>
                <option value="user">User Facing</option>
            </select>
            <br/>
            <div className="grid grid-cols-2 gap-x-4">
                <Button clear id="start-button">Start Scanning</Button>
                <Button clear id="stop-button">Stop Scanning</Button>
            </div>
            </div>
        )
    }

    componentWillUnmount() {
        // TODO(mebjas): See if there is a better way to handle
        //  promise in `componentWillUnmount`.
        //this.CustomQrcodePlugin.clear().catch(error => {
        //    console.error("Failed to clear CustomQrcodePlugin. ", error);
        //});
    }

    componentDidMount() {
        const video = document.getElementById('qr-video');
        //const videoContainer = document.getElementById('video-container');
        const camList = document.getElementById('cam-list');

        const scanner  = new QrScanner(video, result => this.props.qrCodeSuccessCallback(result.data), {highlightScanRegion: true});
        scanner.setInversionMode("both");
        
        scanner.start().then(() => {
            // List cameras after the scanner started to avoid listCamera's stream and the scanner's stream being requested
            // at the same time which can result in listCamera's unconstrained stream also being offered to the scanner.
            // Note that we can also start the scanner after listCameras, we just have it this way around in the demo to
            // start the scanner earlier.
            QrScanner.listCameras(true).then(cameras => cameras.forEach(camera => {
                const option = document.createElement('option');
                option.value = camera.id;
                option.text = camera.label;
                camList.add(option);
            }));
        }).then(scanner.stop());  

        camList.addEventListener('change', event => {
            scanner.setCamera(event.target.value);
        });

        document.getElementById('start-button').addEventListener('click', () => {
            scanner.start();
            //scanner.turnFlashOn();
        });
    
        document.getElementById('stop-button').addEventListener('click', () => {
            scanner.stop();
            //scanner.turnFlashOff();
        });

    }
};

export default CustomQrcodePlugin;
